import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { OptionChipDirective, SelectChipInputComponent } from './select-chip-input.component';

@NgModule({
  imports: [CommonModule, OptionChipDirective, SelectChipInputComponent],
  exports: [SelectChipInputComponent, OptionChipDirective],
})
export class SelectChipInputModule {}
